import { i18n } from '@/plugins/i18n';
import { useAlertStore } from '@/stores/alert';
import { IAppError } from '@/types/response';
import { isInCapacitorApp } from '@/utils/device';
import redirectToLoginPage, { goToMobileLoginPage } from '@/utils/redirectToLoginPage';

export default function getError4xx(error: IAppError) {
  const { status } = error;
  const isNative = isInCapacitorApp();

  const handleNoAuth = () => {
    const message = {
      title: i18n.global.t('access_denied_title'),
      message: i18n.global.t('access_denied_message'),
    };
    const confirm = () => {
      // 셀프서비스에서 401이 발생했을 경우 셀프서비스 로그인 페이지로 이동

      if (location.pathname.includes('/ss')) {
        let destinationUrl = '/login/ss';
        const partnerCode = localStorage.getItem('partner-code-admin');
        if (partnerCode) {
          destinationUrl += `?partnerCode=${partnerCode}`;
        }
        window.location.replace(destinationUrl);
      } else {
        // 일반 로그인 페이지로 이동
        redirectToLoginPage();
      }
    };

    if (localStorage.getItem('authToken') || sessionStorage.getItem('authToken')) {
      localStorage.removeItem('authToken');
      sessionStorage.removeItem('authToken');

      Object.assign(message, {
        title: i18n.global.t('authentication_expired_title'),
        message: i18n.global.t('authentication_expired_message'),
      });
    }

    useAlertStore().alert(message, { confirm }, false);
    return {};
  };

  switch (status) {
    case 400:
      if (location.pathname.includes('login')) {
        return;
      }
      break;
    // 401: 로그인 인증만료
    case 401: {
      if (isNative) {
        goToMobileLoginPage();
        break;
      }
      handleNoAuth();
      break;
    }
    default:
      return error;
  }
}
